module.exports = __webpack_public_path__ + "img/foot-link2.71240ad0.png";